import {Calendar} from 'lucide-react';
import {useAuth} from "@/provider/AuthProvider";
import {myAcademy} from "@/lib/services/academyService";
import {CalendarOutlined, ClockCircleOutlined} from "@ant-design/icons";
import WelcomeDashboardBox from "@/components/welcomeDashboard/WelcomeDashboardBox";

export default function StudentWelcomeSection() {

    return (<WelcomeDashboardBox mode={'student'} />)
}
